// extracted by mini-css-extract-plugin
module.exports = {"module":"ReportBase_module__1Jirj"};